import http from './http'

const featureRoute = '/feature/'

export default {
    async getFeatures () {
        return http.get(featureRoute)
    },
    async getFeatureByName (name) {
        return http.get(featureRoute + '/' + name)
    }
}
